module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "footer-content align-center"
  }, [_c('p', [_vm._v("You gotta get in touch with us! Let's make some really great stuff.")]), _vm._v(" "), _c('contact-button')], 1), _vm._v(" "), _c('div', {
    staticClass: "footer-footer"
  }, [_c('div', {
    staticClass: "left-side"
  }, [_c('social-icons', {
    attrs: {
      "scale": 1.5,
      "twitter": _vm.studio308.links.twitter,
      "github": _vm.studio308.links.github,
      "instagram": _vm.studio308.links.instagram,
      "linkedin": _vm.studio308.links.linkedin,
      "google-plus": _vm.studio308.links.google_plus,
      "facebook": _vm.studio308.links.facebook
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right-side"
  }, [_c('copyright')], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d4c324a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageFooter.vue
// module id = 923
// module chunks = 1